export default __webpack_public_path__ + "static/media/arpa2.6d82eaf9.mp3";